import { literals } from "@/constants/literals";
import ScanCode from "@/pages/capture/components/ScanCode";
import InputText from "@/components/input-text/InputText";
import LightRadioGroup from "@/pages/capture/components/LightRadioGroup";
import type { ExitGarageData } from "@/types/types.d";

interface ExitGarageInputsProps {
  exitGarageData: ExitGarageData | null;
  changeExitGarageData: <Key extends keyof ExitGarageData>(
    id: Key,
    value: ExitGarageData[Key],
  ) => void;
}

const ExitGarageInputsl = ({
  exitGarageData,
  changeExitGarageData,
}: ExitGarageInputsProps) => {
  return (
    <>
      <div className="w-full mb-4 md:w-[calc(50%-16px)]">
        <InputText
          label={literals.orderOut}
          name="orderOut"
          value={exitGarageData?.orderOut || ""}
          onChange={(new_value) => changeExitGarageData("orderOut", new_value)}
          placeholder={literals.outNumberExample}
          size="medium"
          requiredAsterisk
          noBottomSpace
        />
      </div>
      <div className="w-full mb-4 md:w-[calc(50%-16px)]">
        <InputText
          label={literals.serialOutLabel}
          name="serialOut"
          value={exitGarageData?.serialOut || ""}
          onChange={(new_value) => changeExitGarageData("serialOut", new_value)}
          placeholder={literals.outNumberExample}
          size="medium"
          requiredAsterisk
          noBottomSpace
        />
      </div>
      <div className="w-full mb-4">
        <LightRadioGroup
          label={literals.selectDestination}
          onChange={(new_value) =>
            changeExitGarageData("originReturn", new_value)
          }
          selected={exitGarageData?.originReturn}
          required
          noBefore
          customOptionsLabels={{
            yesLabel: literals.returnToOriginLabel,
            noLabel: literals.sendToExits,
          }}
        />
      </div>
      {exitGarageData?.originReturn === false ? (
        <div className="w-full md:w-[calc(50%-16px)]">
          <ScanCode
            label={literals.docu9R1}
            value={exitGarageData?.document9R1 || ""}
            onChange={(new_value) =>
              changeExitGarageData("document9R1", new_value)
            }
            codeType="docu9R1"
          />
        </div>
      ) : null}
    </>
  );
};

export default ExitGarageInputsl;
